import { ReactComponent as Basket } from 'assett/icons/basket.svg';
import { ReactComponent as CloseDialog } from 'assett/icons/close_dialog_icon.svg';
import { deleteDocument } from 'feature/upload/uploadSlice';
import { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store/store';
import { Box, Button, Dialog, IconButton, Typography } from 'styles';
import { STATE_KEYS } from 'types/Store';
import { DocType, IUploadedFileResponse } from 'types/Upload';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';

type Props = {
	documentType: DocType;
	data?: IUploadedFileResponse;
	clearDocumentsKey?: STATE_KEYS;
};

const DeletePopup: FC<Props> = ({ documentType, data, clearDocumentsKey }) => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const dispatch = useDispatch<AppDispatch>();
	const [openDialog, setOpenDialog] = useState(false);

	const documentUuid = data?.uuid;
	const fileName = data?.fileName;

	const onDelete = () => {
		if (!documentUuid) return;

		dispatch(
			deleteDocument({
				uuid: documentUuid,
				docType: documentType,
				clearState: clearDocumentsKey,
			}),
		);
		setOpenDialog(false);
	};

	return (
		<>
			<Dialog
				title={tClientLabels(`dialog.confirm.deleteUploadedFile.${documentType}`)}
				close={
					<IconButton onClick={() => setOpenDialog(false)}>
						<CloseDialog />
					</IconButton>
				}
				open={openDialog}
				variant="confirm"
				events
				actions={
					<>
						<Button variant="outlined" onClick={() => setOpenDialog(false)}>
							{tClientLabels(`dialog.buttons.cancel`)}
						</Button>
						<Button onClick={onDelete} variant="contained">
							{tClientLabels(`dialog.buttons.continue`)}
						</Button>
					</>
				}
				type=""
			>
				<Box display="flex" gap="1rem" flexDirection="column">
					<Typography variant="body">
						<>
							{tClientLabels('dialog.confirm.deleteUploadedFile.content', {
								docName: fileName ? fileName : '',
							})}
						</>
					</Typography>
				</Box>
			</Dialog>

			<IconButton disableTouchRipple onClick={() => setOpenDialog(true)}>
				<Basket />
			</IconButton>
		</>
	);
};

export default DeletePopup;
